import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const UserIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>User</title>
    <path d="M36.9,33.75H31.22l-1.45-3.38c2.08-1.91,4-5.32,5-11.34A11.53,11.53,0,0,0,32.26,9.6a11,11,0,0,0-16.72,0A11.53,11.53,0,0,0,13.06,19c.92,6,2.89,9.42,5,11.34l-1.45,3.38H10.9c-1.95,0-7,1.44-7,8h4c0-3.63,2.32-4,3-4h8.32l2.3-5.36a8.12,8.12,0,0,0,4.77,0l2.3,5.36h8.29c.71,0,3,.37,3,4h4c0-6.56-5.05-8-7-8M17,18.43a7.43,7.43,0,0,1,1.56-6.22,7,7,0,0,1,10.65,0,6.87,6.87,0,0,1,1.4,2.67l-4.72,2V28.24a4.31,4.31,0,0,1-2,.51c-1.59,0-5.45-1-6.88-10.33" />
  </IconBase>
);
